module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"select_all":"%{label}をすべて選択","select_all_items":"すべて選択"}}')
  delete Component.options._Ctor
}
